/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Registry_TokenInputs */



/**
* | output |
* | --- |
* | "Registry token (optional)" |
*
* @param {Partner_Connectors_Field_Registry_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_registry_token = /** @type {((inputs?: Partner_Connectors_Field_Registry_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Registry_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registry-Token (optional)")
	return /** @type {LocalizedString} */ ("Registry token (optional)")
});